/**
 * Las fotos del chat interno, del lado de la pantalla (dirección, 24/9/2026:
 * «¿podría ser que el chat permite mandar fotos?»).
 *
 * Lo que se comprueba aquí es para AVISAR ANTES de subir —un PDF, un vídeo o
 * una foto de 25 MB se dicen al elegirlos, no después de esperar la barra—,
 * pero la regla la pone el servidor (routers/chat_router.py y
 * services/fotos_chat.py), que además mira el CONTENIDO del archivo y no
 * solo su nombre. Los topes son los mismos que allí.
 */

// Los mismos topes que el servidor (fotos_chat.TOPE_BYTES y
// chat_router.TOPE_FOTOS).
export const TOPE_MB_FOTO = 10;
export const TOPE_BYTES_FOTO = TOPE_MB_FOTO * 1024 * 1024;
export const TOPE_FOTOS = 4;

// Lo que ofrece el clip. Tipos CONCRETOS y no `image/*` (dirección, 24/9/2026:
// «pero no sacar foto con el móvil»): se elige de los archivos o de la
// galería. Sin el atributo `capture`, que es el que abre la cámara directa.
export const ACEPTA_FOTOS = 'image/jpeg,image/png,image/webp,image/heic,image/heif';

const TIPOS = new Set(['image/jpeg', 'image/jpg', 'image/pjpeg', 'image/png', 'image/webp',
  'image/heic', 'image/heif']);
// Hay navegadores (Chrome en el ordenador) que no saben qué es un .heic y lo
// mandan sin tipo: entonces manda la extensión.
const EXTENSIONES = /\.(jpe?g|png|webp|heic|heif)$/i;

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/** ¿Dice ser una foto de las que se aceptan? Por su tipo o, sin tipo, por
 *  la extensión (29/9/2026: el clip también ofrece PDF y audios, y cada
 *  archivo se reparte según lo que parece). */
export function pareceUnaFoto(archivo) {
  const tipo = String(archivo?.type || '').toLowerCase();
  return TIPOS.has(tipo) || (!tipo && EXTENSIONES.test(archivo?.name || ''));
}

/** Por qué no vale esta foto, o null si vale. En palabras de la clínica. */
export function motivoNoValida(archivo) {
  if (!archivo) return 'No se ha podido leer el archivo.';
  const nombre = archivo.name ? `«${archivo.name}»` : 'La imagen';
  if (!pareceUnaFoto(archivo)) {
    return `${nombre} no es una foto JPG, PNG, WEBP o HEIC.`;
  }
  if (!archivo.size) return `${nombre} está vacía.`;
  if (archivo.size > TOPE_BYTES_FOTO) {
    const mb = (archivo.size / (1024 * 1024)).toFixed(1).replace('.', ',');
    return `${nombre} pesa ${mb} MB y el máximo son ${TOPE_MB_FOTO} MB.`;
  }
  return null;
}

/** La dirección de una foto de la sala. Con sesión: sin ella, el servidor
 *  contesta 401 (no hay enlaces públicos a las fotos del chat). */
export function urlFoto(sala, id, { miniatura = false, descargar = false } = {}) {
  const base = `${BACKEND_URL}/api/chat/salas/${encodeURIComponent(sala)}/fotos/${encodeURIComponent(id)}`;
  if (miniatura) return `${base}/miniatura`;
  return descargar ? `${base}?descargar=1` : base;
}

/** Lo que identifica un conjunto de fotos para saber si un reintento es el
 *  MISMO envío (mismo id) o uno nuevo. */
export function firmaDeFotos(archivos) {
  return (archivos || []).map((a) => `${a.name}:${a.size}:${a.lastModified || 0}`).join('|');
}
